import { createSelector } from 'reselect'

export const getAdminWelcomeEmail = state => state.get('adminWelcomeEmail')

export const getAdminWelcomeEmailData = createSelector(getAdminWelcomeEmail, welcomeEmail => welcomeEmail.get('data'))

export const getAdminWelcomeEmailDataFilled = createSelector(
  getAdminWelcomeEmailData,
  welcomeEmail => !!welcomeEmail.get('text')
)

export const getAdminWelcomeEmailPending = createSelector(getAdminWelcomeEmail, adminEmail => adminEmail.get('pending'))

export const getAdminWelcomeEmailPendingGet = createSelector(getAdminWelcomeEmailPending, pending => pending.get('get'))

export const getAdminWelcomeEmailPendingSave = createSelector(getAdminWelcomeEmailPending, pending =>
  pending.get('save')
)
